/**
=========================================================
* Soft UI Dashboard PRO React - v3.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard PRO React Base Styles
import colors from '../../colors';
import typography from '../../typography';

// Soft UI Dashboard PRO React Helper Functions
import pxToRem from '../../../functions/pxToRem';

const { transparent, info, secondary, grey } = colors;
const { size } = typography;

export default {
    base: {
        backgroundColor: transparent.main,
        height: 'max-content',
        color: info.main,
        boxShadow: 'none',
        padding: `${pxToRem(6)} ${pxToRem(12)}`,

        '&:hover': {
            backgroundColor: transparent.main,
            boxShadow: 'none',
            color: info.focus,
        },

        '&:focus': {
            boxShadow: 'none',
            color: info.focus,
        },

        '&:active, &:active:focus, &:active:hover': {
            opacity: 0.85,
            boxShadow: 'none',
        },

        '&:disabled': {
            color: grey[600],
            boxShadow: 'none',
        },

        '& .material-icons, .material-icons-round, svg:not(.custom-size), span':
            {
                fontSize: `${pxToRem(20)} !important`,
            },
    },

    small: {
        fontSize: size.xs,
        lineHeight: pxToRem(16),
        '& .material-icons, .material-icons-round, svg:not(.custom-size), span':
            {
                fontSize: `${pxToRem(16)} !important`,
            },
    },

    large: {
        fontSize: size.lg,

        '& .material-icons, .material-icons-round, svg:not(.custom-size), span':
            {
                fontSize: `${pxToRem(24)} !important`,
            },
    },

    primary: {
        color: info.main,
        backgroundColor: transparent.main,

        '&:hover': {
            color: info.focus,
            backgroundColor: transparent.main,
        },

        '&:focus:not(:hover)': {
            color: info.focus,
            backgroundColor: transparent.focus,
            boxShadow: 'none',
        },
    },

    secondary: {
        color: secondary.focus,
        backgroundColor: transparent.main,

        '&:hover': {
            color: secondary.focus,
            backgroundColor: transparent.main,
        },

        '&:focus:not(:hover)': {
            color: secondary.focus,
            backgroundColor: transparent.focus,
            boxShadow: 'none',
        },
    },
};
